import React from "react";
import { inject, observer } from "mobx-react";
import { Redirect } from "react-router-dom";
import {toast} from "react-toastify";

export default (WrappedComponent, requestedPermission = null) => {
  class WithAuth extends React.Component {
    render() {
      const { authStore } = this.props;
      if (authStore.isGettingUser) {
        return null;
      } else if (
        requestedPermission &&
        !authStore.checkPermission(requestedPermission)
      ) {
        toast.error("You are not entitled to this content. If you feel this is in error, please contact Sportybot support.", {
          position: "top-right",
          autoClose: 6000
        });
        return <Redirect to="/" />;
      } else if (authStore.isAuthenticated) {
        return <WrappedComponent {...this.props} />;
      } else {
        return <Redirect to="/login" />;
      }
    }
  }

  return inject("authStore")(observer(WithAuth));
};



// WEBPACK FOOTER //
// ./src/containers/WithAuth.js